import Spreadsheet from "x-data-spreadsheet-wertolet/src";

class SaveRow {
    static columns = ["dateOfPickup", "numberOfContainer", "cargo", "typeOfContainer",
        "dateOfSubmission", "addressOfDelivery", "ourFirm", "client", "formPayAs",
        "summa", "numberOfBill", "dateOfBill", "datePayment", "contractor",
        "driver", "formPayHim", "contractorRate",
        "sumIssued", "numberOfBillAdd", "dateOfPaymentContractor", "manager",
        "clientLead", "departmentHead", "salesManager", "additionalExpenses", "taxes",
        "income", "incomeLearned", "id"];

    constructor() {
        this.dateOfPickup = null;
        this.numberOfContainer = null;
        this.cargo = null;
        this.typeOfContainer = null;
        this.dateOfSubmission = null;
        this.addressOfDelivery = null;
        this.ourFirm = null;
        this.client = null;
        this.formPayAs = null;
        this.summa = null;
        this.numberOfBill = null;
        this.dateOfBill = null;
        this.datePayment = null;
        this.contractor = null;
        this.driver = null;
        this.formPayHim = null;
        this.contractorRate = null;
        this.sumIssued = null;
        this.numberOfBillAdd = null;
        this.dateOfPaymentContractor = null;
        this.manager = null;
        this.clientLead = null;
        this.departmentHead = null;
        this.salesManager = null;
        this.additionalExpenses = null;
        this.taxes = null;
        this.income = null;
        this.incomeLearned = null;
        this.id = null
    }
}

export default SaveRow;
  